module.exports = __webpack_public_path__ + "static/scale-model-of-marquis-de-lafayette-statue-in-baltimore-maryland-0ac7fe2e15eb4a0a62cbec89066a90f4.png";